import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { HelperModule } from 'src/app/helper.module';

import { MainEntregaEquiposComponent } from './main-entrega-equipos/main-entrega-equipos.component';
import { GenerarEntregaEquiposComponent } from './generar-entrega-equipos/generar-entrega-equipos.component';
import { ListarPendientesEntregaEquiposComponent } from './listar-pendientes-entrega-equipos/listar-pendientes-entrega-equipos.component';
import { ListarAsignadosEntregaEquiposComponent } from './listar-asignados-entrega-equipos/listar-asignados-entrega-equipos.component';
import { EditarMovimientoDialogComponent } from './editar-movimiento-dialog/editar-movimiento-dialog.component';
import { EditarLinkDialogComponent } from './editar-link-dialog/editar-link-dialog.component';
import { ReportarIncidenteDialogComponent } from './reportar-incidente-dialog/reportar-incidente-dialog.component';
import { BuscarHistorialTrabajadorComponent } from './buscar-historial-trabajador/buscar-historial-trabajador.component';
import { VincularTrabajadorDialogComponent } from './vincular-trabajador-dialog/vincular-trabajador-dialog.component';

@NgModule({
  declarations: [
    MainEntregaEquiposComponent,
    GenerarEntregaEquiposComponent,
    ListarPendientesEntregaEquiposComponent,
    ListarAsignadosEntregaEquiposComponent,
    EditarMovimientoDialogComponent,
    EditarLinkDialogComponent,
    ReportarIncidenteDialogComponent,
    BuscarHistorialTrabajadorComponent,
    VincularTrabajadorDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    HelperModule
  ],
  exports: [
    MainEntregaEquiposComponent,
    GenerarEntregaEquiposComponent,
    ListarPendientesEntregaEquiposComponent,
    ListarAsignadosEntregaEquiposComponent
  ]
})
export class EntregaEquiposModule { }
